import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import text from 'styles/utility/text.module.scss'
import { NavButton } from 'components/Button'
import { Description } from 'components/Typography'

const InviteMemberTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/mail.svg'} alt={'メンバーを招待しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>メンバーを招待しました</h2>
        <Spacer size={12} />
        <Description align={'center'} description={'招待ステータスは、\n店舗アカウント設定で確認できます。'} />
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'店舗アカウント設定に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/account'} />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default InviteMemberTemplate
